<template>
  <div class="city-manager-expense">
    <div class="h-panel-bar">
      <span class="h-panel-title">城市经理经营费用汇总</span>
      <span class="dark4-color">提示：按 Ctrl + F 键并输入可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
      <account-date-choose v-model="accountDate"/>
<!--      <Button color="primary" class="margin-left" @click="refresh">重新汇总</Button>-->
      <Button color="primary" class="margin-left" @click="exportExcel">导出Excel</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="summaryList" :border="true" :loading="loading" stripe>
        <TableItem title="序号" :width="50">
          <template v-slot="{ index }">{{ index + 1 }}</template>
        </TableItem>
        <TableItem title="城市经理" prop="jingLiName" :width="110"></TableItem>
        <TableItem v-for="col in expenseColumns" :key="col.prop" :title="col.title" :prop="col.prop" align="right"></TableItem>
      </Table>
    </div>
  </div>
</template>
<script>
  import * as XLSX from 'xlsx';
  // 经营费用列定义（与 JingYingDian.vue 的 24 项费用列保持一致）
  const EXPENSE_COLUMNS = [
    {prop: 'h300401', title: '工资'},
    {prop: 'h300402', title: '房租费'},
    {prop: 'h300403', title: '装修费'},
    {prop: 'h300404', title: '燃气水电费'},
    {prop: 'h300405', title: '工商税费'},
    {prop: 'h300406', title: '折旧费'},
    {prop: 'h300407', title: '低值易耗'},
    {prop: 'h300408', title: '修理费'},
    {prop: 'h300409', title: '社保费'},
    {prop: 'h300410', title: '探亲福利费'},
    {prop: 'h300411', title: '电话费'},
    {prop: 'h300412', title: '办公业务费'},
    {prop: 'h300413', title: '差旅费'},
    {prop: 'h300414', title: '市内交通费'},
    {prop: 'h300415', title: '运杂费'},
    {prop: 'h300416', title: '汽车费'},
    {prop: 'h300417', title: '广告费'},
    {prop: 'h300418', title: '公关招待费'},
    {prop: 'h300419', title: '零星购置'},
    {prop: 'h300420', title: '奖品费'},
    {prop: 'h300421', title: '罚款赔偿'},
    {prop: 'h300422', title: '撤店直接损失'},
    {prop: 'h300423', title: '投资损失'},
    {prop: 'h300424', title: '医美费用'},
  ];
  /**
   * 城市经理 - 「经营费用」标签页
   * 按城市经理维度汇总其所辖门店的经营费用：
   * 经理 → 归属该经理的部门(cusColumn15) → 部门对应的费用记录(dianId) → 逐项累加
   */
	export default {
		name: "CityManagerExpense",
    data() {
      return {
        // 会计期间
        accountDate: null,
        // 加载状态
        loading: false,
        // 费用列定义
        expenseColumns: EXPENSE_COLUMNS,
        // 城市经理列表
        jingLiList: [],
        // 部门列表（含城市经理归属 cusColumn15）
        departmentList: [],
        // 经营店费用明细（guanli.list）
        expenseList: [],
        // 汇总结果
        summaryList: [],
      };
    },
    watch: {
      accountDate(newVal) {
        if (!newVal) return;
        // 统一归一到每月 1 号，与经营店汇总口径一致
        const date = new Date(newVal);
        if (date.getDate() !== 1) {
          date.setDate(1);
          const firstDay = date.toISOString().slice(0, 10);
          this.$nextTick(() => {
            if (this.accountDate !== firstDay) {
              this.accountDate = firstDay;
            }
          });
          return;
        }
        // 日期就绪后加载费用并汇总
        this.refresh();
      }
    },
    created() {
      // 非响应式的静态数据加载 Promise 缓存（城市经理、部门只需加载一次）
      this._staticPromise = null;
    },
    mounted() {
      // 预加载城市经理与部门归属数据；accountDate 由 account-date-choose 初始化后触发 watch 汇总
      this.loadStaticData();
    },

    methods: {
      /**
       * 加载城市经理列表
       */
      loadJingLi() {
        return this.$api.report.jingLi.list().then(({data}) => {
          this.jingLiList = data || [];
        });
      },
      /**
       * 加载部门列表及其城市经理归属（cusColumn15）
       */
      loadDepartments() {
        return this.$api.setting.accountingCategory.list().then(({data}) => {
          const department = (data || []).find(item => item.name === '部门');
          if (!department) {
            this.departmentList = [];
            return;
          }
          return this.$api.setting.accountingCategoryDetails.list(department.id).then(({data: detail}) => {
            // 过滤掉管理部门（enable == 1）
            this.departmentList = (detail.records || []).filter(item => item.enable != 1);
          });
        });
      },
      /**
       * 加载静态数据（城市经理 + 部门），使用 Promise 缓存避免重复请求与竞态
       */
      loadStaticData() {
        if (!this._staticPromise) {
          this._staticPromise = Promise.all([this.loadJingLi(), this.loadDepartments()]);
        }
        return this._staticPromise;
      },
      /**
       * 加载费用明细并汇总
       */
      async refresh() {
        if (!this.accountDate) return;
        this.loading = true;
        try {
          // 确保城市经理与部门数据已就绪
          await this.loadStaticData();
          const {data} = await this.$api.bumenhuizong.guanli.list(this.accountDate);
          this.expenseList = data || [];
          this.buildSummary();
        } finally {
          this.loading = false;
        }
      },
      /**
       * 判断部门归属字段 cusColumn15 是否包含指定城市经理 ID
       * 兼容单个 ID、逗号分隔字符串、数组三种形式
       */
      belongsTo(cusColumn15, jingLiId) {
        if (cusColumn15 === undefined || cusColumn15 === null || cusColumn15 === '') return false;
        const ids = Array.isArray(cusColumn15) ? cusColumn15 : String(cusColumn15).split(',');
        return ids.some(id => String(id).trim() === String(jingLiId));
      },
      /**
       * 四舍五入保留 2 位小数
       * @param {Number|String} num 原始数值
       * @returns {Number} 保留两位小数后的数值
       */
      round2(num) {
        return Math.round((Number(num) || 0) * 100) / 100;
      },
      /**
       * 按城市经理维度汇总其所辖门店的各项费用
       */
      buildSummary() {
        this.summaryList = this.jingLiList.map(jl => {
          // 1. 找到归属该经理的部门
          const departments = this.departmentList.filter(dep => this.belongsTo(dep.cusColumn15, jl.id));
          const deptIds = departments.map(d => String(d.id));
          // 2. 匹配这些部门的经营费用记录（费用记录 dianId 对应部门 id）
          const records = this.expenseList.filter(e => deptIds.includes(String(e.dianId)));
          // 3. 逐项累加 24 项费用
          const row = {
            jingLiId: jl.id,
            jingLiName: jl.name,
            storeNames: departments.map(d => d.name).join('、'),
            storeCount: departments.length,
          };
          let total = 0;
          this.expenseColumns.forEach(col => {
            const sum = records.reduce((acc, r) => acc + (Number(r[col.prop]) || 0), 0);
            // 四舍五入保留 2 位小数
            const rounded = this.round2(sum);
            row[col.prop] = rounded;
            total += rounded;
          });
          row.total = this.round2(total);
          return row;
          // 4. 仅展示有归属门店的城市经理
        }).filter(row => row.storeCount > 0);
      },
      /**
       * 导出 Excel
       */
      exportExcel() {
        if (!this.summaryList.length) {
          this.$Message.warning('没有可导出的数据');
          return;
        }
        const data = this.summaryList.map((item, index) => {
          const row = {
            '序号': index + 1,
            '城市经理': item.jingLiName || '',
          };
          this.expenseColumns.forEach(col => {
            row[col.title] = item[col.prop] || 0;
          });
          return row;
        });
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        // 从会计期间解析月份，拼接到名称上便于区分（如：7月）
        const month = this.accountDate ? (new Date(this.accountDate).getMonth() + 1) : '';
        const monthLabel = month ? `${month}月` : '';
        const baseName = monthLabel ? `城市经理经营费用汇总-${monthLabel}` : '城市经理经营费用汇总';
        XLSX.utils.book_append_sheet(wb, ws, baseName);
        XLSX.writeFile(wb, `${baseName}.xlsx`);
        this.$Message.success('数据导出成功，请查看浏览器下载列表');
      },
    }

	};
</script>
<style lang='less' scoped>
  .city-manager-expense {
  .h-panel-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
